<div class="close">
  <button (click)="close()">
    <img
      alt="close"
      width="20"
      height="20"
      src="../../../assets/images/close.svg"
    />
  </button>
</div>
<div class="title">温馨提示</div>
<div class="content">
  <div>确保邮件是已发送！已发送的邮件才能获取。</div>

  <div class="tip">
    <mat-icon style="color: rgb(244, 105, 105)">error</mat-icon>
    不能先点击查询，在点击发送验证码
  </div>
  <div style="margin: 30px 0">页面必须为待输入验证码后，在点击查询</div>
  <img
    src="../../../../assets/images/adobe/tip.png"
    [height]="200"
    width="auto"
    alt=""
  />
  <div>如果验证码错误，可能是获取了之前的验证码。</div>
  <div>请刷新页面后重新点击获取新的。</div>
  <div class="button">
    <button class="button1" (click)="close()">稍后</button>
    <button class="button2" (click)="onOk()">查询</button>
  </div>
</div>
